import React from 'react';
import { SvgIcon } from '../Icon';
import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';

type CarouselNavArrowType = 'next' | 'prev';

interface IProps {
  type: CarouselNavArrowType;
  onClick: () => void;
}

const Container = styled.div<{ $type: CarouselNavArrowType }>`
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 100%;
  z-index: 1;
  color: ${theme.colors.secondary600};
  ${({ $type }) =>
    $type === 'next'
      ? css`
          right: 0;
          background: linear-gradient(
            270deg,
            ${theme.colors.level0} 30.5%,
            rgba(248, 248, 248, 0) 100%
          );
        `
      : css`
          left: 0;
          background: linear-gradient(
            90deg,
            ${theme.colors.level0} 30.5%,
            rgba(248, 248, 248, 0) 100%
          );
        `}
  &:hover {
    cursor: pointer;
    color: ${theme.colors.secondary800};
  }
`;

const CarouselNavArrow = ({ type, onClick }: IProps) => (
  <Container onClick={onClick} $type={type}>
    <SvgIcon
      name={type === 'next' ? 'caret-right' : 'caret-left'}
      width={32}
      height={32}
      customFill="currentColor"
    />
  </Container>
);

export default CarouselNavArrow;
